import React, { useState } from "react";
import { nanoid } from 'nanoid';

import { Container } from "@material-ui/core";
import useStyleRicerca from "../styles/useStyleRicerca";

import { Link } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";

import Jumbotron from "./Jumbotron";

import NotFound from "./NotFound";

const Ricerca = (props) => {
  //console.log(props);
  const { history, match } = props; // da props 'eredito' sia history che match
  const { params } = match; //da match 'individuo' i 'parametri'
  const { ricercaId } = params; //da parametri eredito ricercaId che è l'id selezionato ed inviato con Route

  const classes = useStyleRicerca();

  //const [ricerca, setRicerca] = useState(RData);
  const [ricerca, setRicerca] = useState(
    JSON.parse(localStorage.getItem("tags"))
  );

  let bgImageR;

  //'filtro' in 'cosa' i dati dell'unico record da cercare
  // se fossi certo di avere più risposte dovrei usare .map() per gestirle tutte
  //con filter ritorna un 'array' di object che hanno id=ricercaId presi dall'Hook 'ricerca'
  var cosa = ricerca.filter((item) => item.id == ricercaId);

  //se mi ritorna una array pieno lo 'disegno'
  if (cosa.length !== 0) {
    //console.log(cosa);

    const isResponsabile = () => {
      if (cosa[0].Responsabile.length) {
        return (
          <Grid item xs={12} sm={4} md={3}>
            <Paper className={classes.pannello}>
              <Typography>
                <span>Responsabile/i</span>
              </Typography>
              <Divider />
              <div className={classes.testoCard}>
                <br />
                <ul className={classes.ulla}>
                  {cosa[0].Responsabile.map((responsabili, index) => (
                    <>
                      <li className={classes.topic} key={nanoid()}>
                        {(() => {
                          if (responsabili.link !== "#" && responsabili.link !== "") {
                            return (
                              <Link href={responsabili.link} color="inherit">
                                {responsabili.nome}
                              </Link>
                            );
                          } else {
                            return <span>{responsabili.nome}</span>;
                          }
                        })()}
                      </li>
                      &nbsp;
                    </>
                  ))}
                </ul>
              </div>
            </Paper>
          </Grid>
        );
      }
    };

    const isParoleChiave = () => {
      if (cosa[0].Parole_Chiave.length) {
        return (
          <Grid item xs={12} sm={4} md={4}>
            <Paper className={classes.pannello}>
              <Typography>
                <span>Parole Chiave</span>
              </Typography>
              <Divider />
              <div className={classes.testoTopic}>
                <ul className={classes.ulla}>
                  {cosa[0].Parole_Chiave.map((parole, index) => (
                    <>
                      <li className={classes.topic} key={nanoid()}>
                        #{parole}
                      </li>
                      &nbsp;
                    </>
                  ))}
                </ul>
              </div>
            </Paper>
          </Grid>
        );
      }
    };

    const isUNIFITeam = () => {
      return (
        <Grid item xs={12} sm={6} md={6}>
          {cosa[0].UNIFI_Team[0] && cosa[0].UNIFI_Team[0].nome !== "" && (
            <Paper className={classes.pannello}>
              <Typography>
                <span>UNIFI Team</span>
              </Typography>
              <Divider />
              <div className={classes.testoTopic}>
                <ul className={classes.ulla}>
                  {cosa[0].UNIFI_Team.map((team, index) => (
                    <>
                      <li className={classes.topic} key={nanoid()}>
                        {/* la funzione mi permette di fare if...else*/}
                        {(() => {
                          if (team.link !== "#" && team.link !== "") {
                            return (
                              <Link href={team.link} color="inherit">
                                {team.nome}
                              </Link>
                            );
                          } else {
                            return <span>{team.nome}</span>;
                          }
                        })()}
                      </li>
                      &nbsp;
                    </>
                  ))}
                </ul>
              </div>
            </Paper>
          )}
        </Grid>
      )
    };

    const isPartner = () => {
      return (
        <Grid item xs={12} sm={6} md={6}>
          {cosa[0].Partner[0] && cosa[0].Partner[0].nome !== "" && (
            <Paper className={classes.pannello}>
              <Typography>
                <span>Partner</span>
              </Typography>
              <Divider />
              <div className={classes.testoTopic}>
                <ul className={classes.ulla}>
                  {cosa[0].Partner.map((partner, index) => (
                    <>
                      <li className={classes.topic} key={nanoid()}>
                        {/* la funzione mi permette di fare if...else*/}
                        {(() => {
                          if (partner.link !== "#" && partner.link !== "") {
                            return (
                              <Link href={partner.link} color="inherit">
                                {partner.nome}
                              </Link>
                            );
                          } else {
                            return <span>{partner.nome}</span>;
                          }
                        })()}
                      </li>
                      &nbsp;
                    </>
                  ))}
                </ul>
              </div>
            </Paper>
          )}
        </Grid>
      )
    }

    //Prendo, se c'è, l'immagine dall'object altrimenti ne carico una a caso da unsplash
    // 1279365 - Architecture and Construction
    // 219941 - Architecture, Buildings, Spaces
    // 504554 - found typography
    cosa[0].Media.length && cosa[0].Media[0].cosa
      ? (bgImageR = cosa[0].Media[0].link)
      : (bgImageR =
        "https://source.unsplash.com/collection/1279365/416x230/?sig=" +
        Math.floor(Math.random() * 300));

    return (
      <>
        <Jumbotron BgImage={bgImageR} titolo={cosa[0].titolo} />
        <Container className={classes.pagina}>
          <Grid container spacing={2} className={classes.gridContainer}>
            {/* ANNO */}
            <Grid item xs={6} sm={3} md={2}>
              <Paper className={classes.pannello}>
                <Typography>
                  <span>Anno di avvio</span>
                </Typography>
                <Divider />
                <div className={classes.anno}>{cosa[0].anno_di_avvio}</div>
              </Paper>
            </Grid>
            {/* Tipologia */}
            <Grid item xs={12} sm={4} md={3}>
              <Paper className={classes.pannello}>
                <Typography>
                  <span>Tipologia</span>
                </Typography>
                <Divider />
                <div className={classes.testoCard}>
                  <br />
                  {cosa[0].Tipologia.tipo}
                </div>
              </Paper>
            </Grid>

            {isResponsabile()}

            {isParoleChiave()}

            {isUNIFITeam()}

            {isPartner()}

            <Grid item xs={12} md={6}></Grid>
            <Grid item xs={12} md={6}></Grid>
            <Grid item xs={12} md={6}></Grid>
          </Grid>
        </Container>
        <Container className={classes.abstract}>
          <p>{cosa[0].Abstract.ita}</p>
          {cosa[0].Abstract.eng && (
            <p className={classes.absEng}>{cosa[0].Abstract.eng}</p>
          )}
        </Container>
      </>
    );
  } else {
    // altrimenti 'disegno' NotFound
    return (
      <>
        <NotFound {...props} />
      </>
    );
  }
};

export default Ricerca;
